import { useLocation, Navigate } from "react-router-dom";
import { useState } from "react";
// material
import { styled } from '@mui/material/styles';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { Tooltip,Button } from '@mui/material';
// components
import Page from '../../../components/Page';
import ServicesListing from "../../../components/SidebarMenuComponents/ServiceComponent/ServicesListing";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServicesListingPage() {
    const location = useLocation();
    const serviceMaster = location.state;
    return (
        <Page title="Services Listing | tiketic">
           

                <ServicesListing serviceMaster={serviceMaster} />
            
        </Page>

    );
}

